module.exports = __webpack_public_path__ + "img/judith_c.ab365ff.png";